import Api from "./../api";

class Misc extends Api {
  constructor() {
    super();
    this.uri = "";
    this.requiresAuth = true;
  }

  getPatchNotes() {
    return this.get("/patch/latest", {}, this.requiresAuth);
  }

  getLogs(params) {
    return this.get(
      "/logs" + (params ? "?" + params : ""),
      {},
      this.requiresAuth
    );
  }

  getCmsFeatureOrder(user_id, app_id) {
    return this.get(
      "/app/" + app_id + "/features/" + user_id + "/order",
      this.requiresAuth
    );
  }

  saveCmsFeatureOrder(data, user_id, app_id) {
    return this.post(
      "/app/" + app_id + "/features/" + user_id + "/order",
      data,
      this.requiresAuth
    );
  }

  deleteCmsFeatureOrder(user_id, app_id) {
    return this.delete(
      "/app/" + app_id + "/features/" + user_id + "/order",
      this.requiresAuth
    );
  }

  getSchedule() {
    return this.get("/gestaodehorarios", {}, this.requiresAuth);
  }

  saveSchedule(data) {
    return this.post("/gestaodehorarios", { data }, this.requiresAuth);
  }

  createNotification(data) {
    return this.post("/notifications", data, this.requiresAuth);
  }

  updateNotification(id, data) {
    return this.put("/notifications/" + id, data, this.requiresAuth);
  }

  removeNotification(id) {
    return this.delete("/notifications/" + id, {}, this.requiresAuth);
  }

  getNotification(id) {
    return this.get("/notifications/" + id, {}, this.requiresAuth);
  }
}

export default new Misc();
